import { useEffect, useState } from 'react';
import { LINKEDIN_OAUTH2_STATE, parse } from './utils.js';

export function LinkedInCallback() {
    const [errorMessage, setErrorMessage] = useState('');
    window.opener && window.opener.console.log(""); //"=====In callback (init)==========");
  useEffect(() => {
    const params = parse(window.location.search);
      if (params.state !== localStorage.getItem(LINKEDIN_OAUTH2_STATE)) {
          window.opener && window.opener.console.log("state!=sessionstate: State does not match");
      setErrorMessage('State does not match');
    } else if (params.error) {
      const errorMessage =
            params.error_description || 'Login failed. Please try again.';
        window.opener && window.opener.console.log("params.error found ... "+errorMessage);
      window.opener &&
        window.opener.postMessage(
          {
            error: params.error,
            state: params.state,
            errorMessage,
            from: 'Linked In',
          },
          window.location.origin,
        );
      // Close tab if user cancelled login
      if (params.error === 'user_cancelled_login') {
        window.close();
      }
    }
    if (params.code) {
        window.opener && window.opener.console.log(""); //"\nLINKEDINCALLBACK-------------");
        //window.opener && window.opener.console.log(window.opener.document.getElementById("xmlInput").innerHTML);
      window.opener &&
        window.opener.postMessage(
            { code: params.code, state: params.state, from: 'Linked In' },
          window.location.origin,
        );
    }
  }, []);

  return <div><h1>{errorMessage}</h1></div>;
}
